/**
 * Checks whether the provided input is a function or not, serving as a type guard.
 * @param input unknown
 * @returns boolean
 */
// eslint-disable-next-line @typescript-eslint/ban-types -- We have an exeption for this because in this case we really just want to know if it is function like
export const isFunctionUtil = (input) => typeof input === "function";
export default isFunctionUtil;
